import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { useState, useEffect } from 'react';
import { HelpOutlined } from '@udesk/icons';
import { useReactFlow } from 'reactflow';
import styled from 'styled-components';
import {
    Button,
    Checkbox,
    Form,
    Input,
    InputNumber,
    Popover,
    Radio,
    Select,
    Space,
} from 'udesk-ui';
import { ConditionListGatherForm } from 'Udesk/config/form-config/cus-component-map';
import { RuleList } from './RuleList';
import { findAllSelectedBranch } from './utils/node';
// import { RepeatOutlined } from '@udesk/icons';
// import { getInspectionPointsFlowPointAiNode } from 'src/api/inspectionPoints/flowPoint/aiNode';
// import debounce from 'lodash/debounce';

type CheckboxValueType = string | number | boolean;

const RuleType = {
    Smart: 1,
    LargeModel: 2,
};

const initialValues = {
    conditionList: [
        {
            conditionType: 1, //1话术2交互3特征4信息
            taskConditionId: null,
            orderId: 1,
            operatorType: 10,
            idCode: 'R1',
            operatorList: [
                {
                    applyConditionHitType: 1,
                    applyOperatorScope: {
                        key: 'all',
                        id: 1,
                    },
                    type: 10,
                    operator: 'all',
                    applyRole: 'all',
                },
            ],
            applyConditionId: null,
            applyConditionIdCode: null,
            operator: 'all',
            applyRole: 'all',
            applyScope: null,
            similarityScore: null,
            differWordNumber: null,
            wordPerMinite: null,
            maxWordPerMinite: null,
            grabIntervalTime: null,
            grabMaxSpeakTime: null,
            intervalSecond: null,
            keyword: '',
            semanticSentence: null,
            applyConditionScope: null,
            applyConditionHitType: 1,
            // applyOperatorScope: {
            //     key: 'all',
            //     id: 1
            // },
            param: {},
        },
    ],
    largeModelConditionList: [
        {
            conditionType: 1, //1话术2交互3特征4信息
            taskConditionId: null,
            orderId: 1,
            operatorType: 37,
            idCode: 'R1',
            operatorList: [
                {
                    applyConditionHitType: 1,
                    applyOperatorScope: {
                        key: 'all',
                        id: 1,
                    },
                    type: 37,
                    operator: 'all',
                    applyRole: 'all',
                },
            ],
            applyConditionId: null,
            applyConditionIdCode: null,
            operator: 'all',
            applyRole: 'all',
            applyScope: null,
            similarityScore: null,
            differWordNumber: null,
            wordPerMinite: null,
            maxWordPerMinite: null,
            grabIntervalTime: null,
            grabMaxSpeakTime: null,
            intervalSecond: null,
            keyword: '',
            semanticSentence: null,
            applyConditionScope: null,
            applyConditionHitType: 1,
            // applyOperatorScope: {
            //     key: 'all',
            //     id: 1
            // },
            param: {},
        },
    ],
    ruleList: [{ formula: '', judgeStrategy: 1 }],
    nodeType: RuleType.Smart,
};

const Wrap = styled.div`
    .udesk-qa-ui-input-group {
        display: flex !important;
        align-items: center;
    }

    .check-point-condition-item {
        min-width: auto;
    }
`;

const BaseNodeConfig = (props: any) => {
    const locales = UdeskLocales['current'];
    const { getNodes, getEdges } = useReactFlow();
    const [showInput, setShowInput] = useState(false);
    const [multiBranch, setMultiBranch] = useState(false);
    const [scoreType, setScoreType] = useState(Udesk.enums.calculateScoreTypes.add.id);
    // const [allBranch, setAllBranch] = useState<any[]>([]);
    const [conditionList, setConditionList] = useState<any[]>([]);
    const [form] = Form.useForm();
    const { currentNode, _type, disabled } = props;

    useEffect(() => {
        if (!currentNode) return;
        const nodes = getNodes();

        const { data } = currentNode;
        let { judgeNode: dialogNode, allBranch } = getAllBranch(
            currentNode,
            nodes,
            getEdges(),
            _type
        );

        let initValues = {
            ruleList: allBranch.length
                ? allBranch.reduce<any[]>((res, b: any) => {
                      res.push(...(b.data.ruleList ?? []).map((r) => ({ ...r, nodeId: b.id })));
                      return res;
                  }, [])
                : dialogNode.data.ruleList,
            judgeStrategy: allBranch.length
                ? 31
                : dialogNode.data.ruleList?.[0]?.judgeStrategy || 1,
            conditionList: data.conditionList || initialValues.conditionList,
            nodeType: data.nodeType ?? initialValues.nodeType,
            name: data.name,
            scoreType: data.scoreType,
            predeterminedScore: data.predeterminedScore,
            relateConditionList: data.relateConditionList,
        };

        _type === 'DIALOG_NODE' && setScoreType(initValues.scoreType);
        setShowInput(initValues.judgeStrategy >= 3);
        setMultiBranch(initValues.judgeStrategy > 3);

        setConditionList(dialogNode.data.conditionList || initialValues.conditionList);
        form.setFieldsValue(initValues);
    }, [currentNode, _type]);

    // const onConvertToLargeModel = useMemo(
    //     () =>
    //         debounce(
    //             () => {
    //                 if (currentNode.data?._id && currentNode.data?.pointId) {
    //                     getInspectionPointsFlowPointAiNode({
    //                         params: {
    //                             nodeId: currentNode.data._id,
    //                             pointId: currentNode.data.pointId,
    //                         },
    //                     }).then((res) => {
    //                         setConditionList(res.data || []);
    //                         form.setFieldsValue({
    //                             nodeType: RuleType.LargeModel,
    //                             conditionList: res.data || [],
    //                         });
    //                     });
    //                 }
    //             },
    //             1000,
    //             {
    //                 leading: true,
    //                 trailing: false,
    //             }
    //         ),
    //     [currentNode, form]
    // );

    return (
        <Wrap>
            <Form
                initialValues={initialValues}
                layout="vertical"
                form={form}
                onFinish={(values) => {
                    const relateConditionListMap = (values.relateConditionList || []).reduce(
                        (p, c) => {
                            p[c.idCode] = true;
                            return p;
                        },
                        {}
                    );
                    props.onSubmit?.({
                        ...values,
                        relateConditionList: conditionList.map((c) => {
                            let highlight = 0;
                            if (relateConditionListMap[c.idCode]) {
                                highlight = 1;
                            }
                            return {
                                idCode: c.idCode,
                                highlight,
                            };
                        }),
                        ruleList: values.ruleList?.map((r) => ({
                            ...r,
                            judgeStrategy: Math.min(3, values.judgeStrategy),
                        })),
                        // preNodeType: 'DIALOG_NODE'
                    });
                }}
            >
                <Form.Item
                    name="name"
                    label={
                        /* 节点名称 */ UdeskLocales['current'].pages.tasks.manage.template
                            .checkPoint.detail.components.flow.nodeConfig.nodeName
                    }
                    rules={[{ required: true }]}
                >
                    <Input disabled={disabled} />
                </Form.Item>

                <Form.Item
                    label={
                        /* 节点规则 */ UdeskLocales['current'].pages.tasks.manage.template
                            .checkPoint.detail.components.flow.nodeConfig.nodeRules
                    }
                >
                    <div style={{ marginBottom: 8 }}>
                        <Space align="baseline" size="small">
                            <Form.Item name="nodeType" noStyle>
                                <Radio.Group
                                    options={[
                                        {
                                            label: /* 智能规则 */ UdeskLocales['current'].pages
                                                .tasks.manage.template.checkPoint.detail.components
                                                .flow.nodeConfig.smartRules,
                                            value: RuleType.Smart,
                                        },
                                        {
                                            label: (
                                                <>
                                                    <Popover
                                                        content={
                                                            /* 大模型规则已融合至智能规则中，后续不继续迭代，为了更好的体验，建议切换为智能规则。 */ UdeskLocales[
                                                                'current'
                                                            ].pages.tasks.manage.template.checkPoint
                                                                .detail.templateNew
                                                                .theLargeModelRulesHaveBeenIntegratedIntoTheIntelligentRulesAndTheSubsequentIterationWillNotBeContinuedForBetterExperienceItIsRecommendedToSwitchToTheIntelligentRules
                                                        }
                                                    >
                                                        <HelpOutlined style={{ color: 'red' }} />
                                                    </Popover>{' '}
                                                    <span>
                                                        {
                                                            /* 大模型规则 */ UdeskLocales['current']
                                                                .pages.tasks.manage.template
                                                                .checkPoint.detail.components.flow
                                                                .nodeConfig.bigModelRules
                                                        }
                                                    </span>
                                                </>
                                            ),
                                            value: RuleType.LargeModel,
                                        },
                                    ]}
                                    onChange={(e) => {
                                        const conditionList =
                                            e.target.value === RuleType.LargeModel
                                                ? initialValues.largeModelConditionList
                                                : initialValues.conditionList;
                                        setConditionList(conditionList);
                                        form.setFieldsValue({
                                            conditionList,
                                        });
                                    }}
                                />
                            </Form.Item>

                            {/* 转换为大模型规则 */}
                            {/* <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) => {
                                    return (
                                        prevValues.nodeType !== currentValues.nodeType ||
                                        prevValues.conditionList !== currentValues.conditionList
                                    );
                                }}
                            >
                                {({ getFieldsValue }) => {
                                    const isSmartRule =
                                        getFieldsValue().nodeType === RuleType.Smart;

                                    return props.showTransToLargeModel &&
                                        isSmartRule &&
                                        currentNode?.data?.nodeType !== RuleType.LargeModel ? (
                                        <Button
                                            type="link"
                                            icon={<RepeatOutlined />}
                                            onClick={debounce(onConvertToLargeModel, 1000, {
                                                leading: true,
                                                trailing: false,
                                            })}
                                        >
                                            {
                                                UdeskLocales['current'].pages.tasks.manage.template
                                                    .checkPoint.detail.templateNew
                                                    .convertToLargeModelRules
                                            }
                                        </Button>
                                    ) : null;
                                }}
                            </Form.Item> */}
                        </Space>
                    </div>

                    <div>
                        <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => {
                                return (
                                    prevValues.nodeType !== currentValues.nodeType ||
                                    prevValues.conditionList !== currentValues.conditionList
                                );
                            }}
                        >
                            {({ getFieldsValue }) => {
                                const isLargeModelRule =
                                    getFieldsValue().nodeType === RuleType.LargeModel;

                                return (
                                    <Form.Item
                                        name="conditionList"
                                        rules={[{ required: true }]}
                                        noStyle
                                    >
                                        <ConditionListGatherForm
                                            type={[props.inspectDataSource]}
                                            isWechatQa={false}
                                            isSales={false}
                                            onChange={setConditionList}
                                            disabled={disabled}
                                            isLargeModelRule={isLargeModelRule}
                                            key={isLargeModelRule ? 'largeModel' : 'smartRules'}
                                            showMultiModal
                                            isAutoAssociateDateSource={
                                                props.inspectDataSource !==
                                                Udesk.enums.inspectDataSources.mixedType.id
                                            }
                                            showSmartModelType
                                        />
                                    </Form.Item>
                                );
                            }}
                        </Form.Item>
                    </div>
                </Form.Item>

                {_type === 'DIALOG_NODE' && (
                    <Form.Item
                        label={
                            /* 评分逻辑 */ UdeskLocales['current'].pages.tasks.manage.template
                                .checkPoint.detail.components.flow.nodeConfig.scoringLogic
                        }
                        rules={[{ required: true }]}
                    >
                        <Input.Group compact>
                            <div>
                                {/* 分值： */}
                                {
                                    UdeskLocales['current'].pages.tasks.manage.template.checkPoint
                                        .detail.components.flow.nodeConfig.score
                                }
                            </div>
                            <Form.Item name="scoreType" noStyle rules={[{ required: true }]}>
                                <Select
                                    style={{ width: 80 }}
                                    options={Udesk.enums.calculateScoreTypes.map((i) => ({
                                        label: i.name,
                                        value: i.id,
                                    }))}
                                    onChange={setScoreType}
                                    disabled={disabled}
                                />
                            </Form.Item>
                            <Form.Item
                                name="predeterminedScore"
                                noStyle
                                rules={[{ required: true }]}
                            >
                                <InputNumber style={{ width: 140 }} disabled={disabled} />
                            </Form.Item>
                        </Input.Group>
                    </Form.Item>
                )}
                <Form.Item
                    name="judgeStrategy"
                    label={
                        /* 规则 */ UdeskLocales['current'].pages.tasks.manage.template.checkPoint
                            .detail.components.flow.nodeConfig.rule
                    }
                    rules={[{ required: true }]}
                >
                    <Radio.Group
                        onChange={(e) => {
                            setShowInput(e.target.value >= 3);
                            setMultiBranch(e.target.value > 3);
                            if (e.target.value >= 3) {
                                form.setFieldsValue({
                                    ruleList: [{}],
                                });
                            }
                        }}
                        disabled={disabled}
                    >
                        <Radio value={1}>
                            {locales.pages.tasks.manage.template.checkPoint.configuration.logic.all}
                        </Radio>
                        <Radio value={2}>
                            {locales.pages.tasks.manage.template.checkPoint.configuration.logic.any}
                        </Radio>
                        <Radio value={3}>
                            {
                                locales.pages.tasks.manage.template.checkPoint.configuration.logic
                                    .customize
                            }
                        </Radio>
                        <Radio value={31}>
                            {/* 多分支逻辑 */}
                            {
                                UdeskLocales['current'].pages.tasks.manage.template.checkPoint
                                    .detail.components.flow.nodeConfig.multiBranchLogic
                            }
                        </Radio>
                    </Radio.Group>
                </Form.Item>
                {showInput && (
                    <Form.Item name="ruleList" rules={[{ required: true }]}>
                        <RuleList
                            conditions={conditionList}
                            multiBranch={multiBranch}
                            scoreType={_type === 'DIALOG_NODE' ? scoreType : undefined}
                            disabled={disabled}
                        />
                    </Form.Item>
                )}
                <Form.Item
                    name="relateConditionList"
                    label={
                        /* 高亮 */ UdeskLocales['current'].pages.tasks.manage.template.checkPoint
                            .detail.components.flow.nodeConfig.highlight
                    }
                >
                    <Highlight conditions={conditionList} disabled={disabled}></Highlight>
                </Form.Item>
            </Form>
            <Button
                type="primary"
                onClick={() => {
                    form.submit();
                }}
                disabled={disabled}
            >
                {/* 提交 */}
                {
                    UdeskLocales['current'].pages.tasks.manage.template.checkPoint.detail.components
                        .flow.nodeConfig.submit
                }
            </Button>
        </Wrap>
    );
};

function getNodeConfigWithType(WrapComponent, type) {
    return function DialogNodeConfig(props) {
        const [state] = useState({ _type: type });
        return <WrapComponent {...props} {...state} />;
    };
}

export const DialogNodeConfig = getNodeConfigWithType(BaseNodeConfig, 'DIALOG_NODE');
export const JudgeNodeConfig = getNodeConfigWithType(BaseNodeConfig, 'JUDGE_NODE');

function Highlight(props) {
    const { conditions, onChange, value, disabled } = props;

    return (
        <Checkbox.Group
            options={conditions?.map((c) => c.idCode) ?? []}
            value={value?.filter((v) => v.highlight)?.map((v) => v.idCode) ?? []}
            onChange={(list: CheckboxValueType[]) => {
                onChange?.(
                    conditions.map((c) => {
                        const res = {
                            idCode: c.idCode,
                            highlight: 0,
                            name: null,
                        };
                        if (list.includes(c.idCode)) {
                            res.highlight = 1;
                        }
                        return res;
                    })
                );
            }}
            disabled={disabled}
        ></Checkbox.Group>
    );
}

function findAllSelectedEdges(edges: any, currentSelectedNode: any, allBranch: any) {
    return edges.filter((e) => {
        return e.source === currentSelectedNode.id && allBranch.find((b) => b.id === e.target);
    });
}

function getAllBranch(currentNode, nodes, edges, type) {
    const { data } = currentNode;

    let judgeNode,
        allBranch: any[] = [],
        allEdges: any[] = [];

    if (data.type === 'BRANCH' || data.type === type) {
        if (data.type === 'BRANCH') {
            judgeNode = nodes.find((n) => n.data.id === data.preId && n.data.type === type);
        }
        if (data.type === type) {
            judgeNode = currentNode;
        }
        if (judgeNode) {
            allBranch = nodes.filter(
                (n) => n.data.preId === judgeNode.id && n.data.type === 'BRANCH'
            );
            // setAllBranch(allBranch);
        }
    }

    allEdges = findAllSelectedEdges(edges, currentNode, findAllSelectedBranch(nodes, currentNode));

    return {
        judgeNode,
        allBranch,
        allEdges,
    };
}
